// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Nav$Web from "lumi-web/lib/es6/src/Nav.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Theme$Web from "lumi-web/lib/es6/src/Theme.res.js";
import * as NavBar$Web from "lumi-web/lib/es6/src/NavBar.res.js";
import * as Route$Dashboard from "./Route.res.js";
import * as Assets$Dashboard from "./Assets.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ChangeLanguage$Web from "lumi-web/lib/es6/src/ChangeLanguage.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Translation$Dashboard from "./Translation.res.js";
import * as Barrier$LumiAuthentication from "lumi-authentication/lib/es6/src/Barrier.res.js";

let Nav = Nav$Web.Make({
  translate: Translation$Dashboard.Provider.translate
});

let RouteNav = Nav$Web.Make({
  translate: Route$Dashboard.Application.T.translate
});

let MapNav = Nav$Web.Make({
  translate: Route$Dashboard.$$Map.Tab.T.translate
});

function NavBar(props) {
  let dispatch = props.dispatch;
  let routeUrl = props.routeUrl;
  let route = props.route;
  let kiosk = props.kiosk;
  let accountDoc = Barrier$LumiAuthentication.Account.useContext();
  let toAuth = Barrier$LumiAuthentication.Dispatch.useContext();
  let mapTabUrl = tab => {
    let map;
    map = typeof route !== "object" ? ({
        map: undefined,
        tab: tab
      }) : ({
        map: route._0.map,
        tab: tab
      });
    return routeUrl({
      TAG: "Map",
      _0: map
    });
  };
  let pages = (onClick, hideTitle, classNameOpt) => {
    let className = classNameOpt !== undefined ? classNameOpt : "";
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(MapNav.Button.make, {
          title: "CurrentOccupation",
          icon: "product-hunt",
          iconVariant: "fab",
          isActive: param => {
            if (typeof route !== "object") {
              return false;
            } else {
              return route._0.tab === "CurrentOccupation";
            }
          },
          hideTitle: hideTitle,
          className: className,
          href: mapTabUrl,
          onClick: onClick
        }),
        JsxRuntime.jsx(MapNav.Button.make, {
          title: "AbandonedVehicles",
          icon: "stopwatch",
          isActive: param => {
            if (typeof route !== "object") {
              return false;
            } else {
              return route._0.tab !== "CurrentOccupation";
            }
          },
          hideTitle: hideTitle,
          className: className,
          href: mapTabUrl,
          onClick: onClick
        }),
        JsxRuntime.jsx(RouteNav.Button.make, {
          title: "Statistics",
          icon: "chart-area",
          isActive: title => Primitive_object.equal(route, title),
          hideTitle: hideTitle,
          className: className,
          href: routeUrl,
          onClick: onClick
        })
      ]
    });
  };
  return JsxRuntime.jsx(NavBar$Web.make, {
    brand: JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("img", {
            height: "28",
            src: Assets$Dashboard.logo
          }),
          className: "navbar-item"
        }),
        pages(param => {}, true, "is-hidden-desktop")
      ]
    }),
    start: hideMenu => {
      let onClick = param => hideMenu();
      return pages(onClick, false, undefined);
    },
    end: param => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(Theme$Web.make, {}),
        JsxRuntime.jsx(ChangeLanguage$Web.make, {}),
        LumiReact.renderIf(undefined, !kiosk, JsxRuntime.jsxs(Nav$Web.DropDown.make, {
          title: accountDoc,
          icon: "user",
          isRight: true,
          children: [
            JsxRuntime.jsx(Nav.Button.make, {
              title: "ChangePassword",
              icon: "lock",
              isRight: true,
              onClick: param => dispatch({
                TAG: "ChangePassword",
                _0: true
              })
            }),
            JsxRuntime.jsx(Nav.Button.make, {
              title: "LogOut",
              icon: "sign-out-alt",
              isRight: true,
              onClick: param => toAuth("PerformLogout")
            })
          ],
          toString: accDoc => Document$LumiStore.contents(accDoc).name
        }))
      ]
    }),
    className: "is-primary"
  });
}

let make = NavBar;

export {
  Nav,
  RouteNav,
  MapNav,
  make,
}
/* Nav Not a pure module */
